export const resourceType = {
  album: 1,
  media: 2,
  member: 3,
  coin: 4,
  goods: 5,
  package: 6,
  studyPackage: 7,
  video: 8,
  lesson: 9
};

/**
 * api_v3_album_get
 * 通过专辑信息的charge决定专辑商品类型
 * charge=0  所有用户都免费
 * charge=1 礼包内的专辑商品
 * charge=2 普通专辑商品
 *
 */
export const albumGoodsType = {
  freeAlbumGoods: 0,
  packageAlbumGoods: 1,
  chargeAlbumGoods: 2
};

/**
 * payment_v1_goods_getGoodsNum_get接口获取
 * canBuy = 0 不可单独购买
 * canBuy = 1 可购买
 *
 */

export const pkgAlbumCanBuy = {
  canBuy: 1,
  forbidBuy: 0
};
